import { render, staticRenderFns } from "./AforoCrear.vue?vue&type=template&id=138125c2&scoped=true"
import script from "./AforoCrear.vue?vue&type=script&lang=js"
export * from "./AforoCrear.vue?vue&type=script&lang=js"
import style0 from "./AforoCrear.vue?vue&type=style&index=0&id=138125c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138125c2",
  null
  
)

export default component.exports